import { render, staticRenderFns } from "./PatientTimelineItem.vue?vue&type=template&id=53d2727a&scoped=true&"
import script from "./PatientTimelineItem.vue?vue&type=script&lang=ts&"
export * from "./PatientTimelineItem.vue?vue&type=script&lang=ts&"
import style0 from "./PatientTimelineItem.vue?vue&type=style&index=0&id=53d2727a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2727a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VAvatar,VIcon,VTimelineItem})
